import util from '../common/util';

export default {
    props: {
        propsToData: Object
    },
    created() {
        if (this.propsToData) {
            this.$watch(
                'propsToData',
                function() {
                    Object.keys(this.propsToData).forEach(key => {
                        const value = this.propsToData[key];
                        this[key] = util.deepClone(value);
                    });
                },
                { immediate: true, deep: true }
            );
        }
    }
};
